// extracted by mini-css-extract-plugin
export default {"notificationCardHeader":"notification-card__notificationCardHeader___cBW7G","notificationCardButton":"notification-card__notificationCardButton___DdXpp"};